import { ThumbnailsAction, ThumbnailsActionKeys } from '../actions/thumbnails';
import { UiAction, UiActionKeys } from '../actions/ui';
import Utils from '../../../utils';
import { Api } from '../../../typings/api';

export interface ThumbnailsState {
	items: {
		[k: number]: Api.EditorThumbnailData;
	};
	isDisplayed: boolean;
	width: number;
	positionsToUpdate: number[] | null;
}

export const INITIAL_WIDTH = 240;
export const MIN_WIDTH = 4;
export const MAX_WIDTH = 440;
export const WIDTH_TO_HIDE = 100;

const thumbnailsInitialState: ThumbnailsState = {
	items: {},
	isDisplayed: true,
	width: INITIAL_WIDTH,
	positionsToUpdate: null,
};

export const thumbnails = (state: ThumbnailsState = thumbnailsInitialState, action: ThumbnailsAction | UiAction): ThumbnailsState => {
	switch (action.type) {
		case ThumbnailsActionKeys.SET_THUMBNAILS:
			return {
				...state,
				items: {
					...state.items,
					...Utils.itemsToById(action.data, 'position'),
				},
			};
		case ThumbnailsActionKeys.SET_THUMBNAILS_TO_UPDATE: {
			if (!action.positions) {
				return {
					...state,
					positionsToUpdate: null,
				};
			}

			return {
				...state,
				positionsToUpdate: state.positionsToUpdate
					? [...new Set([...state.positionsToUpdate, ...action.positions])]
					: action.positions,
			};
		}
		case ThumbnailsActionKeys.SET_THUMBNAIL_VERSION: {
			const newState = Utils.deepCopy(state);

			Object.values(newState.items).forEach((item) => {
				if (action.positions.includes(item.position)) {
					item.version = action.version;
				}
			});

			return newState;
		}
		case ThumbnailsActionKeys.TOGGLE_THUMBNAILS:
			return {
				...state,
				isDisplayed: !state.isDisplayed,
			};
		case ThumbnailsActionKeys.SET_THUMBNAILS_WIDTH:
			return {
				...state,
				width: action.width,
			};
		case UiActionKeys.RESET:
			// positionsToUpdate must be kept when close editor to call thumbnails reprocessing
			return {
				...state,
				items: thumbnailsInitialState.items,
				isDisplayed: true,
				width: INITIAL_WIDTH,
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/reducer/thumbnails.ts